// src/components/NewsSection.jsx
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css"; // ensure package is installed

const defaultPosts = [
  {
    img: "/images/keyword/1.jpg",
    date: "March 29, 2021",
    title: "PG in Pune",
    text:
      'Our PG facilities for females include well-furnished rooms with all essential amenities.',
    href: "/PG-in-Pune",
  },
  {
    img: "/images/keyword/2.jpg",
    date: "March 22, 2021",
    title: "Single Room PG in Pune",
    text:
      "Shree Swami Samarth PG offers a tailored solution for individuals seeking privacy and comfort.",
    href: "/Single-Room-PG-in-Pune",
  },
  {
    img: "/images/keyword/3.jpg",
    date: "March 15, 2021",
    title: " Best PG in Hinjewadi Phase 3",
    text:
      "Shree Swami Samarth PG extends a warm welcome to female residents seeking a comfortable and secure.",
    href: "/Best-PG-in-Hinjewadi-Phase-3-for-Working-Ladies",
  },
];

export default function NewsSection({ posts = defaultPosts }) {
  return (
    <section className="news-section">
      <div className="auto-container">
        {/* Sec Title */}
        <div className="sec-title centered">
          <h2>Our Services</h2>
          <div className="sub-title">
            We provide best services for your stay at our place.
          </div>
          <div className="separator"></div>
        </div>

        <div className="row clearfix">
          {posts.map((p, i) => (
            <div className="news-block col-md-4 col-sm-6 col-xs-12" key={i}>
              <div className="inner-box">
                <a href={p.href}>
                  <div className="image">
                    <img src={p.img} alt={p.title} />
                  </div>
                </a>
                <div className="lower-box">
                  {/* <div className="post-date">
                    <i className="far fa-calendar-alt"></i> {p.date}
                  </div> */}
                  <h3>
                    <a className="text-dark" href={p.href}>{p.title}</a>
                  </h3>
                  <div className="text text-dark">{p.text}</div>
                  <div className="clearfix">
                    <div className="pull-left">
                      <a href={p.href} className="read-more darkcolor">
                        Read More <span className="fa fa-angle-right"></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
